/**
 * CalendarPageV2.tsx — GlowPro (g=true)
 *
 * Wrapper de pantalla completa para CalendarModuleV2.
 * Escapa el padding del Layout con márgenes negativos
 * y aplica el tema oscuro del módulo de calendario.
 */

import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { CalendarModuleV2 } from '../components/calendar/CalendarModuleV2';
import '../components/calendar/calendar-v2.css';

const DECOR = ['🌸', '✨', '🌺', '💖', '✨', '🌷', '✨', '🌸', '✨', '💫'];

export default function CalendarPageV2() {
  const navigate = useNavigate();

  const floatingItems = useMemo(() => {
    return Array.from({ length: 18 }).map((_, i) => ({
      id: i,
      icon: DECOR[Math.floor(Math.random() * DECOR.length)],
      left: `${(Math.random() * 96) + 2}vw`,
      delay: `${Math.random() * 15}s`,
      duration: `${15 + Math.random() * 20}s`,
      size: `${0.8 + Math.random() * 1.5}rem`,
      isTwinkle: Math.random() > 0.65
    }));
  }, []);

  return (
    <div
      className="cal-v2-root relative overflow-hidden"
      data-app="glow"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 10,
      }}
    >
      {/* Lava Lamp blurred Orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-fuchsia-300 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob" style={{ animation: 'lava-lamp 15s infinite alternate' }}></div>
      <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob" style={{ animation: 'lava-lamp 20s infinite alternate-reverse', animationDelay: '2s' }}></div>
      <div className="absolute -bottom-10 left-1/3 w-96 h-96 bg-rose-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob" style={{ animation: 'lava-lamp 18s infinite alternate', animationDelay: '4s' }}></div>

      {/* Background Decor */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
        {floatingItems.map(item => (
          <div
            key={item.id}
            className={item.isTwinkle ? "twinkle-star" : "floating-decor"}
            style={{
              left: item.left,
              top: item.isTwinkle ? `${10 + Math.random() * 80}vh` : undefined,
              fontSize: item.size,
              animationDelay: item.delay,
              animationDuration: item.isTwinkle ? `${2 + Math.random() * 4}s` : item.duration,
            }}
          >
            <div style={{ animation: item.isTwinkle ? 'none' : `sway ${2 + Math.random() * 3}s ease-in-out infinite alternate` }}>
              {item.icon}
            </div>
          </div>
        ))}
      </div>

      <div className="relative flex-1 flex flex-col w-full h-full" style={{ zIndex: 10 }}>
        <CalendarModuleV2 g={true} onBack={() => navigate('/')} />
      </div>
    </div>
  );
}
